/** Iniciais do nome para o avatar: "Helena Duarte" vira "HD". */
export function iniciais(nome = '') {
  return String(nome).trim().split(/\s+/).slice(0, 2).map((p) => p[0] || '').join('').toUpperCase();
}

/** Primeiro nome, para a saudação: "Helena Duarte" vira "Helena". */
export function primeiroNome(nome = '') {
  return String(nome).trim().split(/\s+/)[0] || '';
}
